import { render, staticRenderFns } from "./HuddleSkeleton.vue?vue&type=template&id=04cfd5d2&scoped=true"
import script from "./HuddleSkeleton.vue?vue&type=script&lang=js"
export * from "./HuddleSkeleton.vue?vue&type=script&lang=js"
import style0 from "./HuddleSkeleton.vue?vue&type=style&index=0&id=04cfd5d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cfd5d2",
  null
  
)

export default component.exports